import angular from 'angular';
import RecommendedProductsController from '../product-recommandation/recommendedproducts.controller';
import RecommendedProductsService from '../product-recommandation/recommendedproducts.service';

let ProductRecommendation = angular
    .module('ProductRecommendation', [])
    .controller('RecommendedProductsController', RecommendedProductsController)
    .service('RecommendedProductsService', RecommendedProductsService);

export default ProductRecommendation;

